import Vue from "vue";
import Router from "vue-router";

import auth from "./auth";

import Home from "./views/home-page";
import Login from "./views/login-form";
import CustomerPage from "./views/CustomerPage";
import CluePage from "./views/CluePage";
import PersonGroupPage from "./views/PersonGroupPage";
import BillPage from "./views/BillPage";
import KeFuPage from "./views/KeFuPage";
import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";
// eslint-disable-next-line no-unused-vars
import wechatTags from "@/views/wechatPush/messageManage/wechatTags";
// eslint-disable-next-line no-unused-vars
import sendMessage from "@/views/wechatPush/messageManage/sendMessage";
// eslint-disable-next-line no-unused-vars
import tasksMessage from "@/views/wechatPush/messageManage/tasksMessage";
// eslint-disable-next-line no-unused-vars
import marketingBirthday from "@/views/wechatPush/marketing/marketingBirthday";
// eslint-disable-next-line no-unused-vars
import markeingActivity from "@/views/wechatPush/marketing/markeingActivity";
// eslint-disable-next-line no-unused-vars
import marketingList from "@/views/wechatPush/marketing/marketingList";
import contentPage from "@/views/wechatPush/marketing/ContentPage";

Vue.use(Router);

//获取原型对象的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location){
  return originalPush.call(this,location).catch(err=>err)
}

const router = new Router({
  routes: [
    {path: "/home", name: "home", meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Home
      }
    },
    {path: "/CustomerPage", name: "CustomerPage", meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: CustomerPage
      }
    },
    {path: "/CluePage", name: "CluePage",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: CluePage
      }
    },
    {path: "/PersonGroupPage", name: "PersonGroupPage",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: PersonGroupPage
      }
    },
    {path: "/BillPage", name: "BillPage",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: BillPage
      }
    },
    {path: "/KeFuPage", name: "KeFuPage",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: KeFuPage
      }
    },
    {path: "/login-form", name: "login-form",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: () =>
          import(/* webpackChunkName: "login" */ "./views/login-form")
      },
      props: {
        layout: {
          title: "客户关系管理系统"
        }
      }
    },
    // {path: "/login-code", name: "login-code-form",
    //   meta: { requiresAuth: false },
    //   components: {
    //     layout: simpleLayout,
    //     content: () =>
    //         import(/* webpackChunkName: "login" */ "./views/login-code-form")
    //   },
    //   props: {
    //     layout: {
    //       title: "客户关系管理系统"
    //     }
    //   }
    // },
    {
      path: "/reset-password",
      name: "reset-password",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: () =>
          import(/* webpackChunkName: "login" */ "./views/reset-password-form")
      },
      props: {
        layout: {
          title: "Reset Password",
          description: "Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
        }
      }
    },
    // {
    //   path: "/create-account",
    //   name: "create-account",
    //   meta: { requiresAuth: false },
    //   components: {
    //     layout: simpleLayout,
    //     content: () =>
    //       import(/* webpackChunkName: "login" */ "./views/create-account-form")
    //   },
    //   props: {
    //     layout: {
    //       title: "新用户注册"
    //     }
    //   }
    // },
      {
          path: "/register",
          name: "register",
          meta: { requiresAuth: false },
          components: {
              layout: simpleLayout,
              content: () =>
                  import(/* webpackChunkName: "login" */ "./views/register")
          },
          props: {
              layout: {
                  title: "个人注册"
              }
          }
      },
    {
      path: "/change-password",
      name: "change-password",
      meta: { requiresAuth: false },
      components: {
        layout: simpleLayout,
        content: () =>
          import(/* webpackChunkName: "login" */ "./views/change-password-form")
      },
      props: {
        layout: {
          title: "修改密码"
        }
      }
    },
    {
      path: "/",
      // redirect: "/home"
      redirect: "/login-form"
    },
    {
      path: "/login-form",
      components: Login
    },
    {
      path: "/recovery",
      redirect: "/home"
    },
    {
      path: "*",
      redirect: "/home"
    },
  ]
});

router.beforeEach((to, from, next) => {
  let user = localStorage.getItem("storageUser")

  if (to.name === "home" && auth.loggedIn()) {
    if(null == user){
      next({ name: "login-form" });
    }
    next();
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.loggedIn()) {
      next({
        name: "login-form",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
